import BlogFAQ from "./BlogFAQ";

const BlogFAQWithProps = ({ blok }) => {
  return <BlogFAQ blok={blok} theme={blok.theme || "lightGray"} />;
};

export default BlogFAQWithProps;
